import React, { useEffect, useState, useContext, useMemo } from "react";
import LoaderSpiner from "../../components/LoaderSpiner/LoaderSpiner";
import { httpService } from "../../services/httpService";
import {
  FaTimes,
  FaUser,
  FaFileInvoice,
  FaReceipt,
  FaStickyNote,
} from "react-icons/fa";
import { format } from "date-fns";
import DynamicTable from "../../components/common/DynamicTable";
import { TokenContext } from "../../context/TokenContext";
import { useProfile } from "../../context/ProfileContext";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import BookingDetailsDrawer from "../Orders/BookingDetailsDrawer";
import POSDetailsDrawer from "../Orders/POSDetailsDrawer";
import FilterBar from "../../components/common/FilterBar";
import { useColor } from "../../hooks/color/useColor";
import OrderNumberBadge from "../../components/common/OrderNumberBadge";
import AddNewClientAppointment from "../Calendar/BigCalendar/appointmentcalendar/AddNewClientAppointment";
import ClientDetailsDrawer from "../Orders/ClientDetailsDrawer";
import PetDetailsDrawer from "../Orders/PetDetailsDrawer";
import { ALL_RANGE_OPTIONS } from "../common/dateRange";
import useDateRangeFilter from "../common/useDateRangeFilter";
import OrderPaymentDrawer from "../../components/Order/OrderPaymentDrawer";
import AppointmentConfirmTooltip from "../../components/common/AppointmentConfirmTooltip";
import OnlineOrderPopup from "../../components/common/OnlineOrderTooltip";
import BookingOrderPopup from "../../components/common/BookingOrderTooltip";
import OrderCheckinDrawer from "../../components/Order/OrderCheckinDrawer";
import GroomingStartedDrawer from "../services/GroomingStartedDrawer";
import VetClinicStartedDrawer from "../services/VetClinicStartedDrawer";
import BoardingStartedDrawer from "../services/BoardingStartedDrawer";
import OrderCheckoutDrawer from "../../components/Order/OrderCheckoutDrawer";
import PetServiceCategoryDrawer from "../Orders/PetServiceCategoryDrawer";
import ThemeMaker from "../../components/thememaker";
import OrderPaymentReceiptsDrawer from "../../components/Order/OrderPaymentReceiptsDrawer";
import { useLocation } from "react-router-dom";

const OnlineAppointment = () => {
  const { decodedData } = useContext(TokenContext);
  const { isMenuAllowed } = useProfile();
  const { getColor } = useColor();
  const location = useLocation();
  useEffect(() => {
    const orderIdFromState = location.state?.order_id;

    // No order_id in state → do nothing
    if (!orderIdFromState) return;
    handleOpenOrderPopup(location.state);

  }, [location.state?.order_id]); // only re-run when the state changes

  const hasServiceManagementPermission = isMenuAllowed("Service Management");

  // ─── STATES ──────────────────────────────────────────────────────────────────
  const [appointmentData, setAppointmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [showBookingDetails, setShowBookingDetails] = useState(false);
  const [showPOSDetails, setShowPOSDetails] = useState(false);
  const [drawerMode, setDrawerMode] = useState("details");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
  const [paymentOrderId, setPaymentOrderId] = useState(null);
  const [referenceId, setReferenceId] = useState(null);
  const [showOrderPopup, setShowOrderPopup] = useState(false);
  const [selectedOrderData, setSelectedOrderData] = useState(null);

  // Receipt modal state
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [selectedReceipt, setSelectedReceipt] = useState(null);

  const [showClientDrawer, setShowClientDrawer] = useState(false);
  const [selectedClientData, setSelectedClientData] = useState(null);
  const [showClientEditDrawer, setShowClientEditDrawer] = useState(false);
  const [showPetDetailsDrawer, setShowPetDetailsDrawer] = useState(false);
  const [selectedPetData, setSelectedPetData] = useState(null);
  const [selectedPetClientData, setSelectedPetClientData] = useState(null);

  const [scheduleTooltip, setScheduleTooltip] = useState({
    visible: false,
    refId: null,
    position: { x: 0, y: 0 },
    placement: "bottom",
  });

  const [notesPopup, setNotesPopup] = useState({
    open: false,
    notes: "",
  });

  const [showFullNotes, setShowFullNotes] = useState(false);

  const [rescheduleDrawer, setRescheduleDrawer] = useState({
    isOpen: false,
    appointment: null,
  });

  const [bookingPopup, setBookingPopup] = useState({
    isOpen: false,
    orderId: null,
    highlightRefId: null,
    isQueue: null,
  });
  const [serviceInitializationDrawerOpen, setServiceInitializationDrawerOpen] =
    useState(false);
  const [selectedCheckinOrderId, setSelectedCheckinOrderId] = useState(null);
  const [groomingStartedDrawerOpen, setGroomingStartedDrawerOpen] =
    useState(false);
  const [vetStartedDrawerOpen, setVetStartedDrawerOpen] = useState(false);
  const [boardingStartedDrawerOpen, setBoardingStartedDrawerOpen] =
    useState(false);
  const [selectedStartedBooking, setSelectedStartedBooking] = useState(null);
  const [selectedStartedRow, setSelectedStartedRow] = useState(null);
  const [checkoutDrawerOpen, setCheckoutDrawerOpen] = useState(false);
  const [checkoutOrderId, setCheckoutOrderId] = useState(null);

  // ─── DATE FILTER ─────────────────────────────────────────────────────────────
  const {
    dateFilterState,
    activeRange,
    handleDateChange,
    handleRangeChange,
    handleClearDateFilter,
  } = useDateRangeFilter("this_week", () => {});

  // ─── DATE UTILITY ─────────────────────────────────────────────────────────────
  const formatDateSafe = (dateString, formatString = "dd-MM-yyyy") => {
    if (!dateString) return "No Date Alloted";
    try {
      const date = new Date(dateString);
      return isNaN(date.getTime())
        ? "Invalid Date"
        : format(date, formatString);
    } catch {
      return "Invalid Date";
    }
  };

  // ─── API ──────────────────────────────────────────────────────────────────────
  const buildAPIPayload = () => {
    const payload = { dateType: "list" };

    if (dateFilterState.start) payload.fromDate = dateFilterState.start;
    if (dateFilterState.end) payload.toDate = dateFilterState.end;
    if (activeFilters.payment) payload.paymentStatus = activeFilters.payment;
    if (selectedStatusFilter) payload.filterStatus = selectedStatusFilter;

    return payload;
  };

  const fetchAppointmentData = async () => {
    setLoading(true);
    try {
      const payload = buildAPIPayload();
      const response = await httpService.post(
        "/vendororder/getOnlineAppointments",
        payload,
      );

      if (response?.code === 200) {
        const data = response.data || [];

        // Data is already flattened from backend - each object is a separate row
        const processedData = data.map((item) => {
          const isBoarding =
            item.type === "boarding" || item.type === "day_care";
          let dateDisplay = item.start_date;

          // Format date range for boarding
          if (
            isBoarding &&
            item.end_date &&
            item.start_date !== item.end_date
          ) {
            dateDisplay = `${formatDateSafe(item.start_date)} - ${formatDateSafe(item.end_date)}`;
          } else if (item.start_date) {
            dateDisplay = formatDateSafe(item.start_date);
          }

          return {
            ...item,
            order_id: item.order_id || item._id,
            date_display: dateDisplay,
            service_type: item.service_type || item.type,
          };
        });

        setAppointmentData(processedData);
        setStaffList(extractStaff(processedData));
      } else {
        toast.error("Failed to load online appointments");
        setAppointmentData([]);
      }
    } catch (err) {
      console.error("❌ Error fetching online appointments:", err);
      toast.error("Failed to load online appointments");
      setAppointmentData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppointmentData();
  }, [
    activeFilters,
    dateFilterState.start,
    dateFilterState.end,
    selectedStatusFilter,
  ]);

  // Expose for external refresh
  useEffect(() => {
    window.refreshOnlineAppointmentData = fetchAppointmentData;
    return () => {
      delete window.refreshOnlineAppointmentData;
    };
  }, []);

  const extractStaff = (data) => {
    const map = new Map();
    data.forEach(({ technician_id, employee_name }) => {
      if (technician_id && employee_name && !map.has(technician_id))
        map.set(technician_id, { key: technician_id, label: employee_name });
    });
    return Array.from(map.values()).sort((a, b) =>
      a.label.localeCompare(b.label),
    );
  };

  // ─── INVOICE AND RECEIPT HANDLERS (from Orders file) ──────────────────────────
  const handleDownloadInvoice = async (row) => {
    try {
      const vendorId = decodedData?.data?.vendor?._id;
      if (!vendorId || !row?.order_id) {
        toast.error("Missing invoice details");
        return;
      }

      const invoiceRes = await httpService.get(
        `/invoice/getorderinvoice?orderId=${row.order_id}&vendorId=${vendorId}`,
      );

      if (invoiceRes?.status && invoiceRes?.data?.invoice_url) {
        window.open(
          invoiceRes.data.invoice_url,
          "_blank",
          "noopener,noreferrer",
        );
      } else {
        toast.error(invoiceRes?.message || "Failed to fetch invoice");
      }
    } catch (err) {
      console.error("Failed fetching invoice", err);
      toast.error("Failed to fetch invoice");
    }
  };

  const handleOpenPaymentReceipts = (row) => {
    try {
      const receipts =
        row?.order_payments
          ?.flatMap((payment) => payment?.payment_details || [])
          ?.filter((receipt) => receipt?.receipt_url)
          ?.sort(
            (a, b) =>
              new Date(b?.payment_date || 0) - new Date(a?.payment_date || 0),
          ) || [];

      if (receipts.length === 0 && row?.receipt_url) {
        receipts.push({
          _id: row.order_id,
          receipt_url: row.receipt_url,
          paid_amount: row.total_paid_amount || row.paid_amount || 0,
          payment_mode:
            row.order_payments?.[0]?.payment_details?.[0]?.payment_mode || "",
          payment_date:
            row.order_payments?.[0]?.payment_details?.[0]?.payment_date ||
            row.createdAt,
        });
      }

      if (!receipts.length) {
        toast.error("No receipts found");
        return;
      }

      setSelectedReceipt({
        orderNumber: row.order_number,
        customer: {
          name: row.client_name,
          phone: row.phone,
        },
        receipts,
      });

      setShowReceiptModal(true);
    } catch (err) {
      //console.error(err);
      toast.error("Failed to load receipts");
    }
  };

  const handleOpenOrderPopup = async (row) => {
    const response = await httpService.get(
      `/vendororder/getvendororder/${row.order_id}`,
    );

    if (response?.code === 200) {
      setSelectedOrderData(response.data);
      setShowOrderPopup(true);
    }
  };

  const normalizeBookingData = (data = {}) => ({
    order_id: data.order_id || "",
    booking_id: data.ref_id || "",
    orderNumber: data.order_number || "",
    status: data.status,
    order_notes: data?.order_notes || "",
    customer: {
      customerId: data.vendor_client_id || "",
      name: `${data.client_first_name || ""} ${data.client_last_name || ""}`.trim(),
      phone: data.phone || "",
      email: data.email || "",
      address: data.address || {},
    },
    pet: {
      pet_id: data.pet_id || "",
      vendor_pet_id: data.vendor_pet_id || "",
      type: data.pet_type || "",
      breed: data.pet_breed || "",
      size: data.pet_size || "",
      age: data.pet_age || "",
      gender: data.pet_gender || "",
      tags: data.pet_tags || [],
      name: data.pet_name || "",
    },
    service: {
      service_id: data.service_id || "",
      service_name: data.service_name || "",
      service_code: data.service_code || "",
      service_category_id: data.service_category_id || "",
      service_category_name: data.service_category_name || "",
      service_type_id: data.service_type_id || "",
      service_type_name: data.service_type_name || "",
      duration: data.duration || "",
      addons: data.addons || [],
      start_date: data.start_date || "",
      start_time: data.start_time || "",
      datetime: data.datetime || "",
      unit_price_with_tax: data.unit_price_with_tax || 0,
      staffId: data.technician_id || "",
      staffName: data.employee_name || "",
      notes: data?.notes || "",
    },
    vendor: {
      vendorId: data.ref_id || "",
      name: data.vendor_name || "",
      companyName: data.vendor_company_name || "",
      brandName: data.vendor_brand_name || "",
      type: data.vendor_type || "",
      address: data.vendor_address || {},
    },
    pricing: {
      price:
        data?.grand_total ||
        (data?.additional_amount || 0) + data.total_price ||
        0,
      paidAmount: data.paid_amount || 0,
      waivedAmount: data.waived_amount || 0,
      paymentStatus: data.payment_status || "unpaid",
      total:
        data?.grand_total ||
        (data?.additional_amount || 0) + data.total_price ||
        0,
    },
    consent: {
      file: data.consentFile || null,
      uploadedAt: data.consentUploadedAt || null,
      required: true,
    },
    media: {
      before: data.beforeMedia || [],
      after: data.afterMedia || [],
    },
    notes: {
      notes: data.notes || "",
      files: [],
    },
    system: {
      createdAt: data.createdAt || null,
      updatedAt: data.updatedAt || null,
    },
  });

  const openServiceInitializationDrawer = (data) => {
    setSelectedCheckinOrderId(data.order_id || data.orderId);
    setServiceInitializationDrawerOpen(true);
  };

  const handleOpenCheckoutDrawer = (orderId) => {
    setCheckoutDrawerOpen(true);
    setCheckoutOrderId(orderId);
  };

  const getBookingType = (row = {}, typeHint = "") =>
    String(
      typeHint || row.item_type || row.type || row.service_type || "",
    ).toLowerCase();

  const openStartedDrawer = (row, typeHint = "") => {
    const bookingType = getBookingType(row, typeHint);
    const normalizedBooking = normalizeBookingData(row);
    setSelectedStartedBooking(normalizedBooking);
    setSelectedStartedRow(row);

    setGroomingStartedDrawerOpen(false);
    setVetStartedDrawerOpen(false);
    setBoardingStartedDrawerOpen(false);

    if (bookingType === "boarding" || bookingType === "day_care") {
      setBoardingStartedDrawerOpen(true);
    } else if (bookingType === "vet" || bookingType === "vet_clinic") {
      setVetStartedDrawerOpen(true);
    } else {
      setGroomingStartedDrawerOpen(true);
    }
  };

  const handlePostCheckin = async (service_ref_id, type, order_id) => {
    setServiceInitializationDrawerOpen(false);
    setSelectedCheckinOrderId(null);

    try {
      const itemType = getBookingType({}, type);
      const isBoarding =
        itemType === "boarding" || itemType === "day_care";

      const response = await httpService.get(
        isBoarding
          ? `/vendorbooking/getVendorBooking/${service_ref_id}`
          : `/vendorappointment/getVendorAppointment/${service_ref_id}`,
      );

      const fetched = response?.data ?? response;
      if (!fetched) {
        toast.error("Unable to load updated service details");
        return;
      }

      const updatedBooking = {
        ...fetched,
        ref_id:
          fetched?.ref_id ||
          fetched?._id ||
          service_ref_id,
        service_ref_id:
          fetched?.service_ref_id ||
          fetched?.ref_id ||
          fetched?._id ||
          service_ref_id,
        order_id:
          fetched?.order_id ||
          fetched?.orderId ||
          order_id ||
          "",
        vendor_pet_id:
          fetched?.vendor_pet_id ||
          fetched?.pet_id ||
          "",
      };

      setGroomingStartedDrawerOpen(false);
      setVetStartedDrawerOpen(false);
      setBoardingStartedDrawerOpen(false);

      if (isBoarding) {
        const normalizedBooking = normalizeBookingData(updatedBooking);
        setSelectedStartedBooking({
          ...normalizedBooking,
          booking_id:
            updatedBooking?.ref_id ||
            updatedBooking?._id ||
            service_ref_id,
          order_id: updatedBooking?.order_id || order_id || "",
          status: updatedBooking?.status || "started",
        });
        setSelectedStartedRow(updatedBooking);
        setBoardingStartedDrawerOpen(true);
        return;
      }

      const normalizedBooking = normalizeBookingData(updatedBooking);
      setSelectedStartedBooking(normalizedBooking);
      setSelectedStartedRow(updatedBooking);

      if (itemType === "vet" || itemType === "vet_clinic") {
        setVetStartedDrawerOpen(true);
      } else {
        setGroomingStartedDrawerOpen(true);
      }
    } catch (error) {
      console.error("Error opening started drawer after check-in:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to load updated service details",
      );
    }
  };

  const handleRowClick = async (row) => {
    const status = (row.status || "").toLowerCase();
    const isQueue = Number(row.is_queue);

    if (status === "started") {
      openStartedDrawer(row);
      return;
    }

    if (status === "completed" || status === "closed") {
      handleOpenCheckoutDrawer(row.order_id);
      return;
    }

    if (status === "booked") {
      await handleOpenOrderPopup(row);
      return;
    }

    if (status === "confirmed") {
      if (!row.order_id) {
        toast.warning("No order ID available for this booking");
        return;
      }
      setBookingPopup({
        isOpen: true,
        orderId: row.order_id,
        highlightRefId: row.ref_id,
        isQueue,
      });
    }
  };

  const handleAcceptSuccess = ({ orderId, flow, highlightRefId }) => {
    setShowOrderPopup(false);
    setSelectedOrderData(null);

    if (flow === "scheduled") {
      setSelectedCheckinOrderId(orderId);
      setServiceInitializationDrawerOpen(true);
      return;
    }

    setBookingPopup({
      isOpen: true,
      orderId,
      highlightRefId,
      isQueue: 1,
    });
  };

  const handleScheduleSuccess = (orderId) => {
    setBookingPopup({
      isOpen: false,
      orderId: null,
      highlightRefId: null,
      isQueue: null,
    });
    setSelectedCheckinOrderId(orderId);
    setServiceInitializationDrawerOpen(true);
  };

  // ─── HANDLERS ─────────────────────────────────────────────────────────────────
  const handlePaymentFilterChange = (val) => {
    if (!val) {
      setActiveFilters((p) => {
        const n = { ...p };
        delete n.payment;
        return n;
      });
    } else {
      setActiveFilters((p) => ({ ...p, payment: val }));
    }
  };
  const handleStaffChange = (val) => setSelectedStaff(val);

  const openBookingDetails = (booking, mode = "details") => {
    const orderId = booking.order_id || booking.orderId || booking.ref_id;
    if (!orderId) {
      Swal.fire(
        "Error",
        "Unable to open appointment - missing order ID",
        "error",
      );
      return;
    }
    setSelectedOrderId(orderId);
    setDrawerMode(mode);
    if (booking?.shouldOpenItem) setReferenceId(booking?.ref_id);
    hasServiceManagementPermission === false
      ? setShowPOSDetails(true)
      : setShowBookingDetails(true);
  };

  const handleCloseBookingDetails = () => {
    setShowBookingDetails(false);
    setSelectedOrderId(null);
    setDrawerMode("details");
    setReferenceId(null);
    fetchAppointmentData();
  };

  const handleClosePOSDetails = () => {
    setShowPOSDetails(false);
    setSelectedOrderId(null);
    setDrawerMode("details");
    fetchAppointmentData();
  };

  // Client drawer
  const handleClientNameClick = (row) => {
    const clientAppointments = appointmentData
      .filter((i) => i.vendor_client_id === row.vendor_client_id)
      .map((i) => ({
        _id: i._id,
        order_number: i.order_number,
        order_type: i.order_type,
        service_name: i.service_name,
        date: i.start_date,
        total_price: i.total_price || 0,
        paid_amount: i.paid_amount || 0,
        payment_status: i.payment_status || "unpaid",
        grand_total: i.grand_total || 0,
        status: i.status,
        activityType: i.type === "boarding" ? "boarding" : "appointment",
        order_id: i.order_id,
      }));
    window.petAppointments = clientAppointments;

    setSelectedClientData({
      _id: row.vendor_client_id,
      firstname: row.client_first_name,
      lastname: row.client_last_name,
      phone: row.phone || "",
      email: row.email || "",
      address: row.address || null,
    });
    setShowClientDrawer(true);
  };

  // Pet drawer
  const handleFetchPetDetails = async (vendorPetId) => {
    try {
      const res = await httpService.get(
        `/vendorpet/getvendorpet/${vendorPetId}`,
      );
      if (res.code === 200 && res.data) return res.data;
    } catch {
      /* silent */
    }
    return null;
  };

  const handlePetNameClick = async (row) => {
    setLoading(true);
    try {
      const clientAppointments = appointmentData
        .filter((i) => i.vendor_client_id === row.vendor_client_id)
        .map((i) => ({
          _id: i._id,
          order_number: i.order_number,
          service_name: i.service_name,
          date: i.start_date,
          total_price: i.total_price || 0,
          payment_status: i.payment_status || "unpaid",
          status: i.status,
          order_id: i.order_id,
        }));
      window.petAppointments = clientAppointments;

      const complete = row.vendor_pet_id
        ? await handleFetchPetDetails(row.vendor_pet_id)
        : null;
      setSelectedPetData(
        complete
          ? { ...complete, vendor_client_id: row.vendor_client_id }
          : {
              _id: row.vendor_pet_id || "unknown",
              name: row.pet_name,
              breed: { breed_name: row.pet_breed || "" },
              pet_type: { name: row.pet_type || "" },
              size_details: { size_label: row.pet_size || "" },
              tags: row.pet_tags || [],
              vendor_client_id: row.vendor_client_id,
            },
      );
      setSelectedPetClientData({
        _id: row.vendor_client_id,
        firstname: row.client_first_name,
        lastname: row.client_last_name,
        phone: row.phone || "",
        email: row.email || "",
      });
      setShowPetDetailsDrawer(true);
    } catch {
      toast.error("Failed to open pet details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setNotesPopup((prev) => ({
        ...prev,
        open: false,
      }));
    };

    if (notesPopup.open) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [notesPopup.open]);

  // ─── FILTERED DATA ────────────────────────────────────────────────────────────
  const filteredData = useMemo(() => {
    let result = appointmentData;
    if (selectedStaff)
      result = result.filter((i) => i.technician_id === selectedStaff);
    if (activeFilters.payment)
      result = result.filter(
        (i) =>
          i.payment_status?.toLowerCase() ===
          activeFilters.payment.toLowerCase(),
      );
    if (selectedStatusFilter)
      result = result.filter(
        (i) => i.status?.toLowerCase() === selectedStatusFilter.toLowerCase(),
      );
    return result;
  }, [
    appointmentData,
    selectedStaff,
    activeFilters.payment,
    selectedStatusFilter,
  ]);

  // ─── TABLE CELLS ──────────────────────────────────────────────────────────────
  const TruncatedText = ({ text, maxLength = 15 }) => {
    if (!text) return "Not Available";
    const truncated = text.length > maxLength;
    return (
      <span
        title={truncated ? text : undefined}
        className={truncated ? "cursor-help hover:text-blue-600" : ""}
      >
        {truncated ? text.substring(0, maxLength) + "..." : text}
      </span>
    );
  };

  const AmountDisplay = ({ row }) => {
    const paymentKey = row.payment_status?.toLowerCase().includes("unpaid")
      ? "notPaid"
      : row.payment_status?.toLowerCase().includes("partial")
        ? "partialPaid"
        : row.payment_status?.toLowerCase().includes("paid")
          ? "paid"
          : "notPaid";

    const paymentColor = getColor("paymentStatus", paymentKey);
    const isPartial = row.payment_status?.toLowerCase().includes("partial");
    const totalAmount = row.grand_total || row.total_price || 0;
    const paidAmount = row.paid_amount || 0;

    return (
      <div className="relative group inline-block">
        <span
          className="font-semibold px-2 py-1 rounded border border-black text-black text-sm min-w-[80px] inline-block text-center"
          style={{ background: paymentColor }}
        >
          ₹{Number(totalAmount).toFixed(0)}
        </span>
        {isPartial && (
          <div className="absolute bottom-full left-0 mb-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap z-10">
            Paid: ₹{paidAmount}
          </div>
        )}
      </div>
    );
  };

  // ─── COLUMNS ──────────────────────────────────────────────────────────────────
  const columns = [
    {
      key: "order_number",
      header: "Order ID",
      sortable: true,
      renderCell: (row) => (
        <div className="flex flex-col items-center gap-2">
          {/* Order Number */}
          <OrderNumberBadge
            orderNumber={row.order_number}
            orderType={row.order_type || "online"}
            className="text-xs px-2 py-1 rounded-md font-semibold border border-black flex items-center justify-center min-w-[100px]"
          />
          {/* Amount below buttons */}
          <AmountDisplay row={row} />

          {/* Buttons directly below Order ID */}
          <div className="flex items-center gap-2">
            {/* <button
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadInvoice(row);
              }}
              className="p-1.5 rounded-md bg-blue-50 hover:bg-blue-100 text-blue-600 transition-colors"
              title="Download Invoice"
            >
              <FaFileInvoice className="w-3.5 h-3.5" />
            </button> */}

            <button
              onClick={(e) => {
                e.stopPropagation();
                handleOpenPaymentReceipts(row);
              }}
              className="p-1.5 rounded-md bg-purple-50 hover:bg-purple-100 text-purple-600 transition-colors"
              title="Payment Receipt"
            >
              <FaReceipt className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      ),
    },
    {
      key: "client_first_name",
      header: "Client details",
      sortable: true,
      renderCell: (row) => (
        <div className="flex flex-col items-start">
          <div
            className="font-medium text-sm text-blue-600 hover:text-blue-900 hover:underline cursor-pointer transition-colors"
            onClick={(e) => {
              e.stopPropagation();
              handleClientNameClick(row);
            }}
          >
            <TruncatedText
              text={
                row.client_name || row.client_first_name || row.phone || "-"
              }
              maxLength={20}
            />
          </div>
          {row.phone && (
            <span className="text-sm text-gray-700 mt-0.5">{row.phone}</span>
          )}
          {row.email && (
            <span className="text-sm text-gray-700 truncate max-w-[180px]">
              {row.email}
            </span>
          )}
        </div>
      ),
    },
    {
      key: "pet_name",
      header: "Pet",
      sortable: true,
      renderCell: (row) => (
        <div className="flex flex-col items-start">
          {row.pet_name ? (
            <>
              <div
                className="font-medium text-sm text-blue-600 hover:text-blue-800 hover:underline cursor-pointer transition-colors"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePetNameClick(row);
                }}
              >
                <TruncatedText text={row.pet_name} maxLength={15} />
              </div>
              {(row.pet_breed || row.pet_size) && (
                <span className="text-sm text-gray-700 mt-0.5">
                  {[row.pet_breed, row.pet_size].filter(Boolean).join(" · ")}
                </span>
              )}
              {row.pet_type && (
                <span className="text-sm text-gray-700">{row.pet_type}</span>
              )}
            </>
          ) : (
            <span className="text-gray-400 text-sm">-</span>
          )}
        </div>
      ),
    },
    // {
    //   key: "service_type",
    //   header: "Category",
    //   sortable: true,
    //   renderCell: (row) => {
    //     const category = row.service_type || row.type || "General";
    //     const color = getColor("serviceCategoryColors", category);
    //     // Format category display name
    //     let displayCategory =
    //       category.charAt(0).toUpperCase() + category.slice(1);
    //     if (category === "boarding") displayCategory = "Boarding";
    //     if (category === "grooming") displayCategory = "Grooming";
    //     if (category === "vet_clinic") displayCategory = "Vet";
    //     if (category === "dog_walking") displayCategory = "Walking";
    //     return (
    //       <span
    //         className="px-2 py-1 rounded-md text-sm font-medium"
    //         style={{ backgroundColor: color }}
    //       >
    //         {displayCategory}
    //       </span>
    //     );
    //   },
    // },
    {
      key: "service_details",
      header: "Service Details",
      sortable: true,
      renderCell: (row) => {
        const category = row.service_type || row.type || "General";

        let displayCategory =
          category.charAt(0).toUpperCase() + category.slice(1);

        if (category === "boarding") displayCategory = "Boarding";
        if (category === "grooming") displayCategory = "Grooming";
        if (category === "vet_clinic") displayCategory = "Vet";
        if (category === "dog_walking") displayCategory = "Walking";
        if (category === "day_care") displayCategory = "Day Care";

        const price = row.total_price || 0;

        let duration = row.duration || "";

        if (
          (category === "boarding" || category === "day_care") &&
          duration &&
          !String(duration).toLowerCase().includes("day")
        ) {
          duration = `${duration} Days`;
        }

        return (
          <div className="flex flex-col items-start leading-tight">
            <span className="font-semibold text-blue-600 text-sm">
              {displayCategory}
            </span>

            <span className="text-sm text-gray-700">
              {row.service_name || "-"}
            </span>

            <span className="text-sm text-gray-700">
              {duration}
              {duration ? " • " : ""}₹{Number(price).toFixed(0)}
            </span>
          </div>
        );
      },
    },
    {
      key: "date_display",
      header: "Schedule",
      sortable: true,
      renderCell: (row) => {
        const isBoarding = row.type === "boarding";
        let detailsDisplay = [];

        if (isBoarding && row.end_date && row.start_date !== row.end_date) {
          // Boarding date range
          detailsDisplay.push(
            <span key="date" className="font-medium text-sm">
              {formatDateSafe(row.start_date)} - {formatDateSafe(row.end_date)}
            </span>,
          );
          // For boarding, show room type if available (from your image)
          if (row.room_type) {
            detailsDisplay.push(
              <span key="room" className="text-xs text-gray-600">
                Room: {row.room_type}
              </span>,
            );
          }
        } else if (row.start_date) {
          // Regular appointment date
          detailsDisplay.push(
            <span key="date" className="font-medium text-sm">
              {formatDateSafe(row.start_date)}
            </span>,
          );
          // Show time slot
          if (row.start_time) {
            detailsDisplay.push(
              <span key="time" className="text-xs text-gray-600">
                {row.start_time}
              </span>,
            );
          }
        }

        return (
          <div className="flex flex-col items-start">{detailsDisplay}</div>
        );
      },
    },
    {
      key: "notes",
      header: "Notes",
      sortable: false,
      renderCell: (row) => {
        const noteText = row.notes || row.order_notes || "";

        if (!noteText?.trim()) {
          return null;
        }

        return (
          <button
            onClick={(e) => {
              e.stopPropagation();

              setShowFullNotes(false);

              setNotesPopup({
                open: true,
                notes: noteText,
              });
            }}
            className="flex justify-center"
            title="Notes"
          >
            <FaStickyNote className="w-5 h-5 text-gray-600 hover:text-grey-600 transition-colors" />
          </button>
        );
      },
    },
  ];

  // ─── FILTER OPTIONS ───────────────────────────────────────────────────────────
  const paymentFilterOptions = [
    { key: "", label: "Payment Status" },
    { key: "paid", label: "Paid" },
    { key: "partial", label: "Partial" },
    { key: "unpaid", label: "Unpaid" },
  ];

  const staffFilterOptions = useMemo(
    () => [{ key: "", label: "All Staff" }, ...staffList],
    [staffList],
  );

  // ─── RENDER ───────────────────────────────────────────────────────────────────
  return (
    <ThemeMaker>
      {loading && <LoaderSpiner />}

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="p-2">
          {/* Table with mergeConfig for row spanning */}
          <DynamicTable
            columns={columns}
            data={filteredData}
            onRowClick={(row) => handleRowClick(row)}
            //actions={actions}
            emptyMessage="No online appointments found"
            mergeConfig={{
              groupByKey: "order_id", // Group by order_id to merge rows
              mergeColumns: ["order_number", "client_first_name"], // Columns to merge/span
            }}
            rightToolbar={
              <div className="flex flex-wrap items-center gap-4">
                <FilterBar
                  showDatePicker={true}
                  dateFilterState={dateFilterState}
                  onDateChange={handleDateChange}
                  onClearDateFilter={handleClearDateFilter}
                  activeRange={activeRange}
                  onRangeChange={handleRangeChange}
                  rangeOptions={ALL_RANGE_OPTIONS}
                  filters={[
                    ...(staffList.length > 0
                      ? [
                          {
                            type: "select",
                            key: "staff",
                            value: selectedStaff,
                            onChange: handleStaffChange,
                            options: staffFilterOptions,
                          },
                        ]
                      : []),
                    {
                      type: "select",
                      key: "payment",
                      value: activeFilters.payment || "",
                      onChange: handlePaymentFilterChange,
                      options: paymentFilterOptions,
                    },
                  ]}
                />
              </div>
            }
          />
        </div>
      </div>

      {/* ── Drawers ── */}
      <BookingDetailsDrawer
        isOpen={showBookingDetails}
        onClose={handleCloseBookingDetails}
        orderId={selectedOrderId}
        mode={drawerMode}
        ref_id={referenceId}
      />

      <POSDetailsDrawer
        isOpen={showPOSDetails}
        onClose={handleClosePOSDetails}
        orderId={selectedOrderId}
        refreshClients={fetchAppointmentData}
      />

      {showClientDrawer && (
        <ClientDetailsDrawer
          isOpen={showClientDrawer}
          onClose={() => {
            setShowClientDrawer(false);
            setSelectedClientData(null);
          }}
          onEditClick={() => {
            setShowClientDrawer(false);
            setShowClientEditDrawer(true);
          }}
          clientData={selectedClientData}
          petAppointments={window.petAppointments || []}
          petBoarding={[]}
        />
      )}

      {showPetDetailsDrawer && selectedPetData && (
        <PetDetailsDrawer
          isOpen={showPetDetailsDrawer}
          onClose={() => {
            setShowPetDetailsDrawer(false);
            setSelectedPetData(null);
            setSelectedPetClientData(null);
          }}
          petData={selectedPetData}
          clientData={selectedPetClientData}
          clientAppointments={window.petAppointments || []}
          clientBoarding={[]}
          triggergetclientapi={true}
        />
      )}

      {showClientEditDrawer && (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex justify-end">
          <div
            className="h-full w-full md:w-[60vw] lg:w-[60vw] xl:w-2/5 bg-white shadow-2xl overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center gap-3 p-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50 sticky top-0 z-10">
              <button
                onClick={() => {
                  setShowClientEditDrawer(false);
                  setSelectedClientData(null);
                  fetchAppointmentData();
                }}
                className="w-10 h-10 rounded-full hover:bg-white/70 flex items-center justify-center transition"
              >
                <FaTimes className="w-6 h-6 text-gray-700" />
              </button>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center">
                  <FaUser className="w-4 h-4 text-white" />
                </div>
                <h2 className="text-xl font-semibold">Edit Client</h2>
              </div>
            </div>
            <AddNewClientAppointment
              onClose={() => {
                setShowClientEditDrawer(false);
                setSelectedClientData(null);
                fetchAppointmentData();
              }}
              phone={selectedClientData?.phone || ""}
              onSave={() => {
                setShowClientEditDrawer(false);
                setSelectedClientData(null);
                fetchAppointmentData();
              }}
              clientId={selectedClientData?._id}
              isOpen={showClientEditDrawer}
            />
          </div>
        </div>
      )}

      <OrderPaymentDrawer
        isOpen={paymentOrderId !== null}
        onClose={() => setPaymentOrderId(null)}
        orderId={paymentOrderId}
        onPaymentSuccess={() => {
          toast.success("Payment recorded successfully!");
          fetchAppointmentData();
        }}
      />

      <OnlineOrderPopup
        isOpen={showOrderPopup}
        orderData={selectedOrderData}
        onClose={() => setShowOrderPopup(false)}
        refreshData={fetchAppointmentData}
        employees={staffList.map((s) => ({ id: s.key, name: s.label }))}
        onAcceptSuccess={handleAcceptSuccess}
      />

      <BookingOrderPopup
        isOpen={bookingPopup.isOpen}
        orderId={bookingPopup.orderId}
        highlightRefId={bookingPopup.highlightRefId}
        onClose={() =>
          setBookingPopup({
            isOpen: false,
            orderId: null,
            highlightRefId: null,
            isQueue: null,
          })
        }
        refreshData={fetchAppointmentData}
        employees={staffList.map((s) => ({ id: s.key, name: s.label }))}
        mode={bookingPopup.isQueue === 0 ? "scheduled" : "queue"}
        onCheckIn={(item) => openServiceInitializationDrawer(item)}
        onScheduleSuccess={handleScheduleSuccess}
      />

      {serviceInitializationDrawerOpen && (
        <OrderCheckinDrawer
          isOpen={serviceInitializationDrawerOpen}
          onClose={() => {
            setServiceInitializationDrawerOpen(false);
            setSelectedCheckinOrderId(null);
            fetchAppointmentData();
          }}
          orderId={selectedCheckinOrderId}
          onCheckin={async (...args) => {
            await handlePostCheckin(...args);
            fetchAppointmentData();
          }}
        />
      )}

      {groomingStartedDrawerOpen && (
        <GroomingStartedDrawer
          open={groomingStartedDrawerOpen}
          booking={selectedStartedBooking}
          appointmentRow={selectedStartedRow}
          onClose={() => {
            setGroomingStartedDrawerOpen(false);
            setSelectedStartedBooking(null);
            setSelectedStartedRow(null);
            fetchAppointmentData();
          }}
          onSave={() => {
            fetchAppointmentData();
          }}
          onComplete={(orderId) => {
            handleOpenCheckoutDrawer(orderId);
          }}
        />
      )}

      {vetStartedDrawerOpen && (
        <VetClinicStartedDrawer
          open={vetStartedDrawerOpen}
          booking={selectedStartedBooking}
          appointmentRow={selectedStartedRow}
          onClose={() => {
            setVetStartedDrawerOpen(false);
            setSelectedStartedBooking(null);
            setSelectedStartedRow(null);
            fetchAppointmentData();
          }}
          onComplete={(orderId) => {
            handleOpenCheckoutDrawer(orderId);
          }}
        />
      )}

      {boardingStartedDrawerOpen && (
        <BoardingStartedDrawer
          open={boardingStartedDrawerOpen}
          booking={selectedStartedBooking}
          appointmentRow={selectedStartedRow}
          onClose={() => {
            setBoardingStartedDrawerOpen(false);
            setSelectedStartedBooking(null);
            setSelectedStartedRow(null);
            fetchAppointmentData();
          }}
          onComplete={(orderId) => {
            handleOpenCheckoutDrawer(orderId);
          }}
        />
      )}

      {checkoutDrawerOpen && (
        <OrderCheckoutDrawer
          orderId={checkoutOrderId}
          isOpen={checkoutDrawerOpen}
          onClose={() => {
            setCheckoutDrawerOpen(false);
            setCheckoutOrderId(null);
            fetchAppointmentData();
          }}
        />
      )}

      <AppointmentConfirmTooltip
        visible={scheduleTooltip.visible}
        position={scheduleTooltip.position}
        placement={scheduleTooltip.placement}
        refId={scheduleTooltip.refId}
        closeTooltip={() => {
          setScheduleTooltip({
            visible: false,
            refId: null,
            position: { x: 0, y: 0 },
            placement: "bottom",
          });
          fetchAppointmentData();
        }}
        onViewOrder={openBookingDetails}
        onRescheduleClick={(appointment) =>
          setRescheduleDrawer({ isOpen: true, appointment })
        }
      />

      {rescheduleDrawer.isOpen && rescheduleDrawer.appointment && (
        <PetServiceCategoryDrawer
          isOpen={rescheduleDrawer.isOpen}
          onClose={() =>
            setRescheduleDrawer({ isOpen: false, appointment: null })
          }
          onUpdate={() => {
            setRescheduleDrawer({ isOpen: false, appointment: null });
            setScheduleTooltip((p) => ({ ...p, visible: false }));
            fetchAppointmentData();
          }}
          clientId={rescheduleDrawer.appointment?.vendor_client_id}
          clientName={rescheduleDrawer.appointment?.client_name}
          clientNumber={rescheduleDrawer.appointment?.phone}
          itemData={{
            ...rescheduleDrawer.appointment,
            ref_id: rescheduleDrawer.appointment?.ref_id,
            vendor_pet_id: rescheduleDrawer.appointment?.vendor_pet_id,
            service_id: rescheduleDrawer.appointment?.service_id,
            service_type_name:
              rescheduleDrawer.appointment?.service_type || "grooming",
            start_date: rescheduleDrawer.appointment?.start_date,
            start_time: rescheduleDrawer.appointment?.start_time,
            item_type: rescheduleDrawer.appointment?.type || "grooming",
            order_id: rescheduleDrawer.appointment?.order_id,
            technician_id: rescheduleDrawer.appointment?.technician_id,
            employee_name: rescheduleDrawer.appointment?.employee_name,
          }}
          orderId={rescheduleDrawer.appointment?.order_id}
          editMode={true}
          isServiceEditMode={true}
          saleType="appointment"
        />
      )}

      {/* Receipt Drawer */}
      <OrderPaymentReceiptsDrawer
        isOpen={showReceiptModal}
        onClose={() => {
          setShowReceiptModal(false);
          setSelectedReceipt(null);
        }}
        receiptData={selectedReceipt}
      />

      {notesPopup.open && (
        <div
          className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => {
            setNotesPopup({ open: false, notes: "" });
            setShowFullNotes(false);
          }}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-3 py-1 flex justify-between items-center">
              <div>
                <h4 className="text-xl font-bold text-white">Notes...</h4>
              </div>

              <button
                onClick={() => {
                  setNotesPopup({ open: false, notes: "" });
                  setShowFullNotes(false);
                }}
                className="text-white hover:bg-white/20 rounded-full p-2 transition"
              >
                <FaTimes size={18} />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 flex-1 overflow-hidden">
              <div className="bg-gray-50 rounded-xl border border-gray-200 p-5">
                <div
                  className={`overflow-y-auto pr-2 text-gray-700 whitespace-pre-wrap leading-7 ${
                    notesPopup.notes.length > 250 ? "max-h-[50vh]" : ""
                  }`}
                >
                  {showFullNotes ? (
                    <>
                      {notesPopup.notes}
                      {notesPopup.notes.length > 250 && (
                        <button
                          onClick={() => setShowFullNotes(false)}
                          className="ml-2 text-blue-600 font-semibold hover:text-blue-700"
                        >
                          Show Less
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      {notesPopup.notes.length > 250 ? (
                        <>
                          {notesPopup.notes.slice(0, 250)}
                          <button
                            onClick={() => setShowFullNotes(true)}
                            className="text-blue-600 font-semibold hover:text-blue-700 ml-1"
                          >
                            ...Show More
                          </button>
                        </>
                      ) : (
                        notesPopup.notes
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </ThemeMaker>
  );
};

export default OnlineAppointment;
